module.exports = __webpack_public_path__ + "static/media/user-graduate.b4910c27.svg";